import React from 'react';
import { Tag } from 'antd';

interface ActiveFilterChipsProps {
    selectedGroup: string | null;
    onClearGroup: () => void;
    selectedMethods: string[];
    onRemoveMethod: (value: string) => void;
    selectedVersions: string[];
    onRemoveVersion: (value: string) => void;
    selectedStatuses: string[];
    onRemoveStatus: (value: string) => void;
}

/*
 * Dismissible chip row summarizing every active catalog filter.
 */
export function ActiveFilterChips({
    selectedGroup,
    onClearGroup,
    selectedMethods,
    onRemoveMethod,
    selectedVersions,
    onRemoveVersion,
    selectedStatuses,
    onRemoveStatus,
}: ActiveFilterChipsProps) {
    const hasAny =
        selectedGroup || selectedMethods.length > 0 || selectedVersions.length > 0 || selectedStatuses.length > 0;
    if (!hasAny) return null;

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
            {selectedGroup && (
                <Tag closable onClose={onClearGroup}>
                    Group: {selectedGroup}
                </Tag>
            )}
            {selectedMethods.map((method) => (
                <Tag key={method} closable onClose={() => onRemoveMethod(method)}>
                    {method}
                </Tag>
            ))}
            {selectedVersions.map((version) => (
                <Tag key={version} closable onClose={() => onRemoveVersion(version)}>
                    {version}
                </Tag>
            ))}
            {selectedStatuses.map((status) => (
                <Tag key={status} closable onClose={() => onRemoveStatus(status)}>
                    {status}
                </Tag>
            ))}
        </div>
    );
}
